const PracticeAreaList = (): void => {
  const roots = document.querySelectorAll<HTMLElement>('[data-practice-area-list]');

  roots.forEach((root) => {
    const items = Array.from(root.querySelectorAll<HTMLElement>('[data-area-index]'));
    const pictures = Array.from(root.querySelectorAll<HTMLElement>('[data-preview-index]'));

    const activate = (index: number): void => {
      items.forEach((el) => {
        const active = parseInt(el.dataset.areaIndex ?? '0', 10) === index;
        el.classList.toggle('is-active', active);
        el.setAttribute('aria-current', active ? 'true' : 'false');
      });

      pictures.forEach((el) => {
        const isActive = parseInt(el.dataset.previewIndex ?? '0', 10) === index;
        el.classList.toggle('is-active', isActive);
      });
    };

    if (items.length > 0) {
      activate(0);
    }
    
    items.forEach((item) => {
      item.addEventListener('mouseenter', () => {
        activate(parseInt(item.dataset.areaIndex ?? '0', 10));
      });

      item.addEventListener('focus', () => {
        activate(parseInt(item.dataset.areaIndex ?? '0', 10));
      });
    });
  });
};

export default PracticeAreaList;
